import 'react-virtualized/styles.css';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useRoute } from 'react-router5';
import copyToClipboard from 'copy-text-to-clipboard';
import { useDispatch, useSelector } from 'react-redux';

import { authActions, authSelector } from '$store/auth';
import { Button, ModalWrapper, Placeholder, Tabbar, TabbarItem } from '$uikit';
import router, { PWA_ROUTES_EXCLUDE } from 'navigation/router';
import {
  Confirm,
  FraudTerms,
  GenderRequired,
  Loader,
  MetaTags,
  Navbar,
  Prompt,
  PwaBanner,
  Toast,
} from 'shared/components';
import {
  ACCESS_DENIED,
  ADD_ACCOUNT,
  ADS,
  ADULT_AUTH,
  API_TOKEN,
  OAUTH_AUTHORIZE,
  APP,
  APPS_MANAGE,
  AUTH,
  AUTH_EMAIL,
  AUTH_PAGE,
  AUTH_REQUIRED,
  BATTLE,
  BATTLES,
  BIND_EMAIL,
  BIND_EMAIL_CONFIRM,
  BIRTHDAYS,
  BLACK_FRIDAY_2025,
  BLACKLIST,
  BLOCKED,
  COUNTRY_BLOCKED,
  BOT,
  BROADCAST,
  BROADCAST_MESSAGE,
  BROADCAST_STATS,
  BUY_MESSAGE_FAILED,
  CANDY_QR,
  CHAT,
  CLOUD,
  COMMON_FEED,
  CONTENT_PRIORITY,
  CUSTOM_TIPS,
  DASHBOARD,
  DEBUG_PAGE,
  EXPLORE,
  FAQ,
  FEED,
  FEED_PROMOTION,
  FIND_FRIENDS,
  FREE_WRITE,
  GENDER_FILTER,
  GOOGLE_AUTH,
  GROUP,
  GROUPS,
  HOWTO,
  IM,
  INCOGNITO,
  INVITE,
  ISOLATED_MODE,
  LANDING_DIAMOND,
  LANGUAGE,
  LEADERBOARD,
  LEADERBOARD_DETAILS,
  LEADERBOARDS_HISTORY,
  LIST,
  LISTS,
  LIVE,
  MAIN,
  MARYANA_LANDING,
  MEDIA,
  MINE,
  MINE_BOOST,
  MINE_EXPLORE,
  MINE_FRIENDS,
  MINE_SQUAD,
  MINE_SQUAD_BOOST,
  MINE_TOP,
  MODEL_UTM,
  NFT,
  NOTIFY,
  NOTIFY_SETTINGS,
  OFFERS,
  ONLYPAY_ERROR,
  ONLYPAY_SUCCESS,
  OTHER,
  PASSWORD,
  PAY_FORM,
  PAY_TIPS_FAILED,
  PAYMENT_METHODS,
  PERSONAL_SUBSCRIPTION,
  PERSONAL_SUBSCRIPTION_INFO,
  POST_VIEW,
  PRE_LANDING_V1,
  PRE_LANDING_V2,
  PRE_LANDING_V3,
  PROFILE,
  PROFILE_LIVE,
  PROFILE_REDIRECT,
  PROFILE_REELS,
  PROMO,
  PROMO_CODE,
  PWA_IOS,
  RATING,
  REELS,
  REF,
  REFILL_TON,
  REGISTRATION,
  RESOLVE,
  SEARCH,
  PASSKEY,
  SESSIONS,
  SETTINGS,
  SHARE_PROFILE,
  SHOW_SUBSCRIPTION,
  STATISTICS,
  STATISTICS_PRO,
  STATISTICS_PRO_FANS,
  STATISTICS_PRO_LINKS,
  STORAGE,
  STORY_LANDING,
  SUBSCRIPTION_ACTIVATED,
  SUBSCRIPTION_ADULT,
  SUBSCRIPTION_ADULT_ACTIVATED,
  SUBSCRIPTION_AUTHOR,
  SUBSCRIPTION_AUTHOR_ACTIVATED,
  SUBSCRIPTION_AUTHOR_OLD,
  SUBSCRIPTION_BASIC,
  SUBSCRIPTION_FAILED,
  SUBSCRIPTION_INFO,
  SUBSCRIPTION_MEDIA,
  SUBSCRIPTION_MEDIA_ACTIVATED,
  SUBSCRIPTION_TONKEEPER,
  SUBSCRIPTIONS,
  SYSTEM_PROMO_CODE,
  TELEGRAM,
  TOP_UP,
  TOP_UP_FAILED,
  TRIAL_LINK_ACTIVATION,
  TRIAL_LINKS,
  USER_REF,
  VALENTINE_DAY_STICKER,
  VERIFICATION_APPLY,
  VERIFICATION_LANDING,
  VIEW_OFFER,
  VK_AUTH,
  WEBSITE_SETTINGS,
  WELCOME_MESSAGE,
} from '$shared/constants/pages';
import {
  AD_TARGETING,
  ADS_BALANCE,
  ADS_WITHDRAW,
  NEW_AD,
  NEW_AD_CLIP,
  NEW_AD_CLIP_PREVIEW,
  NEW_AD_POST,
  NEW_AD_PROFILE,
} from '$shared/constants/modals';
import feed from '$assets/lottie/feed.json';
import clips from '$assets/lottie/clips.json';
import message from '$assets/lottie/message.json';
import account from '$assets/lottie/account.json';
import search from '$assets/lottie/search.json';
import {
  IcBubble24,
  IcBurger24,
  IcDashboard24,
  IcHome24,
  IcNewYearBubble24,
  IcNewYearBurger24,
  IcNewYearClips24,
  IcNewYearDashboard24,
  IcNewYearHome24,
  IcNewYearSearch24,
  IcSearch24,
  IcUser28,
} from '$assets';
import {
  AccessDenied,
  AddAccount,
  AdPreview,
  Ads,
  AdsBalance,
  AdTargeting,
  AdultAuth,
  AdUsers,
  AdView,
  AdventCalendar,
  AdventCalendarConfiguration,
  AgePopover,
  ApiToken,
  OauthAuthorize,
  App as Application,
  AppsManage,
  AuthEmail,
  AuthPassword,
  AuthRequired,
  Balance,
  BalancePaySheet,
  BasicSubscription,
  Battle,
  BattleDonate,
  Battles,
  BindEmail,
  BindEmailConfirm,
  Birthdays,
  BlackFriday2025,
  Blacklist,
  Blocked,
  BonusFans,
  BonusFansReferrals,
  Bot,
  Bundle,
  BuyMessageFailed,
  Call,
  CandyQr,
  Captcha,
  Chat,
  Cloud,
  CloudNewAlbum,
  CommonFeed,
  ConfirmCode,
  ContentPriority,
  Cover,
  CreateAdventCalendarBundle,
  CreateBundle,
  CreateInvoice,
  CreateMenuSheet,
  Dashboard,
  Domain,
  Edit,
  EditApp,
  EditCountries,
  EditGroup,
  EditOffer,
  EditPost,
  EnableGold,
  Error,
  ExchangeEur,
  Explore,
  Feed,
  FeedPromotion,
  FindFriends,
  Followers,
  FollowSuggestions,
  ForcedPaywall,
  FreeWrite,
  GenderFilter,
  GiftsStore,
  GoogleAuth,
  Group,
  GroupAdmins,
  Groups,
  Incognito,
  Intro,
  Invite,
  IsolatedMode,
  Landing,
  Language,
  Leaderboard,
  LeaderboardDetails,
  LeaderboardsHistory,
  Likes,
  ListAddMember,
  Live,
  MaryanaLanding,
  MediaSubscription,
  MineBoost,
  MineExplore,
  MineExploreCardView,
  MineFriends,
  MineSquad,
  MineSquadBoost,
  MineSquadNew,
  MineTop,
  ModelsLandingV1,
  ModelsLandingV2,
  ModelsLandingV3,
  Monetization,
  NewAd,
  NewAdClip,
  NewAdClipPreview,
  NewAdPost,
  NewAdProfile,
  NewApp,
  NewList,
  NewOffer,
  NewPoll,
  NewPost,
  NewReel,
  NftList,
  NotFound,
  Notify,
  NotifySettings,
  Offers,
  Offline,
  CountryBlocked,
  OnlypayError,
  OnlypaySuccess,
  Other,
  Password,
  Passkey,
  PayForm,
  PaymentMethods,
  PaySheet,
  PayTipsFailed,
  Paywall,
  PersonalSubscription,
  PersonalSubscriptionInfo,
  PlaceSpend,
  Profile,
  Promo,
  PromoCode,
  PromoCodeContent,
  PromotePost,
  PushNotifications,
  PwaIos,
  Rating,
  ReferralsCreateLink,
  ReferralsLinks,
  RefillTon,
  Registration,
  Resolver,
  RouletteLot,
  Scheduled,
  Search,
  SendGift,
  SendValentineDaySticker,
  Sessions,
  Settings,
  ShareProfile,
  ShowSubscription,
  Statistics,
  StatisticsPro,
  StatisticsProFans,
  StatisticsProLinks,
  Status,
  Storage,
  StoryLanding,
  StoryViewer,
  StoryViews,
  Subscription,
  SubscriptionActivated,
  SubscriptionAuthor,
  SubscriptionFailed,
  SubscriptionInfo,
  Subscriptions,
  SubscriptionTonkeeper,
  SystemPromoCode,
  Telegram,
  TelegramBotSheet,
  TelegramChooseChatSheet,
  Tips,
  TopUp,
  TopUpBalanceSheet,
  TopUpFailed,
  TopUpPage,
  TopUpTonSheet,
  TrialLinkActivation,
  TrialLinks,
  CreatePromoLink,
  PromoLinksList,
  UploadVideo,
  UserInfo,
  UsersLists,
  ViewComment,
  ViewerWidget,
  ViewOffer,
  ViewPost,
  ViewTask,
  VkAuth,
  WebsiteSettings,
  WelcomeMessage,
  Withdraw,
  Write,
} from '$core';
import {
  useActionSheet,
  useCurrentUserInfo,
  useDesktop,
  useModalName,
  useTranslator,
  useWikiLink,
} from '$hooks';
import Im from '$core/Im/Im';
import { mainFraudAccepted, mainSelector } from '$store/main';
import { initPush } from '$services/push';
import { goBack } from '$navigation/helper';
import {
  classNames,
  DisplayMode,
  getAccounts,
  getDisplayMode,
  getStorageItem,
  isChristmasHolidays,
  isPWA,
  removeStorageItem,
  setStorageItem,
  setToken,
  statReachGoal,
} from '$utils';
import { postsActions } from '$store/posts';
import { toastActions } from '$store/toast';
import { Sex, SubscriptionType } from '$store/models';
import { Broadcast } from '$core/Broadcast/Broadcast';
import { BroadcastMessage } from '$core/BroadcastMessage/BroadcastMessage';
import { BroadcastStats } from '$core/BroadcastStats/BroadcastStats';
import { UsersList } from '$core/UsersList/UsersList';
import { ContentPriorityType } from '$store/main/interface';
import { ReferralsUsers } from '$core/ReferralsUsers/ReferralsUsers';
import { UsersTabsEnum } from '$core/ReferralsUsers/ReferralsUsers.interface';
import { DynamicComponent } from './DynamicComponent';
import { ContentPriorityPlaceholder } from '$core/Feed/ContentPriorityPlaceholder/ContentPriorityPlaceholder';
import { feedActions } from '$store/feed';
import { NewRoulette } from '$core/NewRoulette/NewRoulette';
import { PayInvoiceSheet } from '$core/PayInvoiceSheet/PayInvoiceSheet';
import { PayConfirmSheet } from '$core/PayConfirmSheet/PayConfirmSheet';
import { PasskeyAuthorization } from '$passkey/PasskeyAuthorization';
import { reelsActions, reelsBadgeSelector } from '$store/reels';
import { Pushes } from '$shared/components/Pushes/Pushes';
import { VerificationLanding } from '$core/VerificationLanding/VerificationLanding';
import { CreateTrialLink } from '$core/CreateTrialLink/CreateTrialLink';
import { trialLinksActions } from '$store/trialLinks';
import { MediaChat } from '$core/MediaChat/MediaChat';
import { ReelsClips } from '$core/Reels/ReelsClips';
import { ReelsAll } from '$core/Reels/ReelsAll';
import { Mine } from '$core/Mine/Mine';
import { CustomTips } from '$core/CustomTips/CustomTips';
import { DebugPage } from '$core/DebugPage/DebugPage';
import Lottie from 'lottie-react';

function getTabs(
  t: any,
  contentPriority: ContentPriorityType,
  isLogged: boolean,
  mVerified,
  isolated: boolean,
) {
  if (!isLogged) {
    return [
      {
        icon: <IcSearch24 />,
        label: t('navbar_search'),
        name: SEARCH,
        activeIcon: <TabLottieIcon data={search} autoplay />,
      },
      {
        icon: <TabLottieIcon data={clips} />,
        activeIcon: <TabLottieIcon data={clips} autoplay />,
        name: REELS,
        label: t('navbar_reels'),
      },
      {
        icon: <IcUser28 />,
        activeIcon: <IcUser28 />,
        name: AUTH_REQUIRED,
        label: t('tabbar_profile'),
      },
    ];
  }

  const isChristmas = isChristmasHolidays();
  const result: any = [
    {
      icon: isChristmas ? <IcHome24 /> : <TabLottieIcon data={feed} />,
      activeIcon: isChristmas ? (
        <IcNewYearHome24 />
      ) : (
        <TabLottieIcon data={feed} autoplay />
      ),
      name: FEED,
      label: t('navbar_news'),
    },
    {
      icon: isChristmas ? <IcSearch24 /> : <TabLottieIcon data={search} />,
      activeIcon: isChristmas ? (
        <IcNewYearSearch24 />
      ) : (
        <TabLottieIcon data={search} autoplay />
      ),

      name: SEARCH,
      label:
        contentPriority === ContentPriorityType.ADULT
          ? t('navbar_search')
          : t('navbar_search'),
    },
    {
      icon: isChristmas ? <IcBubble24 /> : <TabLottieIcon data={message} />,
      activeIcon: isChristmas ? (
        <IcNewYearBubble24 />
      ) : (
        <TabLottieIcon data={message} autoplay />
      ),

      name: IM,
      label: t('navbar_im'),
    },
    contentPriority === ContentPriorityType.ADULT && {
      icon: <TabLottieIcon data={clips} />,
      activeIcon: isChristmas ? (
        <IcNewYearClips24 />
      ) : (
        <TabLottieIcon data={clips} autoplay />
      ),
      name: REELS,
      label: t('navbar_reels'),
    },
    // {
    //   icon: isChristmas ? <IcBell24 /> : <TabLottieIcon data={updates} />,
    //   activeIcon: isChristmas ? (
    //     <IcNewYearBell24 />
    //   ) : (
    //     <TabLottieIcon data={updates} autoplay />
    //   ),
    //
    //   name: NOTIFY,
    //   label: t('navbar_notify'),
    // },
    mVerified
      ? {
          icon: <IcDashboard24 />,
          activeIcon: isChristmas ? <IcNewYearDashboard24 /> : <IcDashboard24 />,
          name: DASHBOARD,
          label: t('navbar_dashboard'),
        }
      : {
          icon: isChristmas ? <IcBurger24 /> : <TabLottieIcon data={account} />,
          activeIcon: isChristmas ? (
            <IcNewYearBurger24 />
          ) : (
            <TabLottieIcon data={account} autoplay />
          ),
          name: OTHER,
          label: t('tabbar_profile'),
        },
  ];

  return result.filter((item) => !!item);
}

function App() {
  const { route } = useRoute();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(OTHER);
  const isDesktop = useDesktop();
  const modalName = useModalName();
  const user = useCurrentUserInfo();
  const t = useTranslator();
  const { mVerified, offline, contentPriority, decryptKeys, showFeatures, error } =
    useSelector(mainSelector);
  const isAdultUser = contentPriority === ContentPriorityType.ADULT;
  const isInAppBrowser = useMemo(() => {
    return false;
    // if (location.hostname === 'tpc.fan') {
    //   return false;
    // }
    //
    // const userAgent = navigator.userAgent.toLowerCase();
    // // @ts-ignore
    // return userAgent.indexOf('instagram') > -1 || window.isFromTelegramInApp;
  }, []);
  const hasReelsBadge = useSelector(reelsBadgeSelector);
  const howToRedirectLink = useWikiLink('/general-information/about-the-platform');
  const isSubscribed = Object.values(decryptKeys).length > 1;

  const isForcePaywall = useMemo(() => {
    if (!isAdultUser) {
      return false;
    }

    if (user.verified > 0) {
      return false;
    }

    if (decryptKeys[-1]) {
      return false;
    }

    return false;
    // return !!showFeatures.eroticSubscription;
  }, [decryptKeys, user, isAdultUser, showFeatures.eroticSubscription]);

  const switchAccount = route?.params ? parseInt(route.params.switchAccount) : null;
  if (switchAccount) {
    const account = getAccounts().find((a) => a.id == switchAccount);
    if (account) {
      setToken(account.id, account.token);
    }
    router.navigate(
      route.name,
      {
        ...route.params,
        switchAccount: undefined,
      },
      { replace: true },
    );
  }

  const { isLoading, isLogged } = useSelector(authSelector);
  const { newDialogs, hasNotify, popup, accounts, showInstallPrompt } =
    useSelector(mainSelector);
  const isFraudAccepted = useSelector(mainFraudAccepted);

  useEffect(() => {
    if (route?.name === TRIAL_LINK_ACTIVATION) {
      setStorageItem('contentPriorityType', ContentPriorityType.ADULT);
      dispatch(trialLinksActions.loadInfo(route.params.hash));
    }
    if (isLogged) {
      const hash = getStorageItem('trialLink');
      if (hash) {
        removeStorageItem('trialLink');
        dispatch(trialLinksActions.loadInfo(hash));
      }
    }
  }, [route?.name, isLoading, isLogged]);

  useEffect(() => {
    if (getDisplayMode() == DisplayMode.STANDALONE) {
      statReachGoal('pwa_user');
    } else {
      statReachGoal('web_user');
    }
  }, []);

  useEffect(() => {
    dispatch(postsActions.sendSeenPosts());

    if (location.hostname === 'tpc.fan') {
      statReachGoal('tpc_fan');
    }
  }, [dispatch, route?.name]);

  useEffect(() => {
    const resizeHandler = () => {
      //if (!isDesktop) {
      const height = Math.max(window.innerHeight, document.body.clientHeight);
      document.documentElement.style.setProperty('--screen-height', height + 'px');
      //}
    };

    window.addEventListener('resize', resizeHandler);
    const interval = setInterval(resizeHandler, 500);
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeHandler);
    };
  }, [isDesktop]);

  useEffect(() => {
    document.body.classList.toggle('webapp', window.isWebApp);

    const html = document.getElementsByTagName('html');
    if (html && html.length) {
      html[0].classList.toggle('webapp', window.isWebApp);
    }
  }, []);

  useEffect(() => {
    if (route?.name === PROFILE_REDIRECT) {
      if (user.id) {
        router.navigate(
          RESOLVE,
          { domain: user.domain || `id${user.id}` },
          { replace: true },
        );
      } else {
        router.navigate(MAIN, {}, { replace: true });
      }
    } else if (route?.name === SUBSCRIPTION_AUTHOR_OLD) {
      router.navigate(
        SUBSCRIPTION_AUTHOR,
        { authorId: route.params.authorId },
        { replace: true },
      );
    } else if (route?.name === LIVE) {
      router.navigate(FEED, { w: `live${route.params.id}` }, { replace: true });
    } else if (route?.name === PROFILE_LIVE) {
      router.navigate(RESOLVE, { domain: route?.params?.domain, w: `live_profile` });
    } else if (route?.name === DASHBOARD && !mVerified && !isLoading) {
      router.navigate(FEED);
    } else if (route?.name === USER_REF) {
      router.navigate(RESOLVE, route.params);
    } else if (route?.name == MODEL_UTM) {
      router.navigate(RESOLVE, route.params);
    }
  }, [user, route?.name, mVerified, isLoading]);

  useEffect(() => {
    dispatch(authActions.init());
  }, [dispatch]);

  useEffect(() => {
    if (isLogged) {
      initPush(dispatch);
    }
  }, [dispatch, isLogged]);

  useEffect(() => {
    let names = getTabs(t, contentPriority, isLogged, mVerified, user.isolated).map(
      (tab) => tab.name,
    );
    if (route?.name && names.indexOf(route.name) > -1) {
      setActiveTab(route.name);
    }
  }, [route?.name, t, contentPriority, isLogged, mVerified]);

  const handleTab = useCallback(
    (name) => () => {
      if (name === route?.name) {
        const scrollNode = document.querySelector('._ScrollView');
        scrollNode && scrollNode.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        if (name === FEED) {
          dispatch(feedActions.clearFeed());
        } else if (name === REELS && name !== activeTab) {
          dispatch(reelsActions.reset());
        }

        router.navigate(name, {}, { replace: true });
      }
    },
    [activeTab, route],
  );

  const modal = useMemo(() => {
    const name = modalName;
    let matches: any = null;

    if (name === 'new_list') {
      return <NewList />;
    } else if (name === 'mine_squad_new') {
      return <MineSquadNew />;
    } else if (name === 'cloud_album_create') {
      return <CloudNewAlbum />;
    } else if (name === 'post') {
      return <NewPost key={`post_${user.id}`} ownerId={user.id} />;
    } else if (name === 'status') {
      return <Status />;
    } else if (name === 'edit') {
      return <Edit />;
    } else if (name === 'write') {
      return <Write />;
    } else if (name === 'domain') {
      return <Domain />;
    } else if (name === 'balance') {
      return <Balance />;
    } else if (name === 'withdraw') {
      return <Withdraw />;
    } else if (name === 'top_up') {
      return <TopUp />;
    } else if (name === 'create_invoice') {
      return <CreateInvoice />;
    } else if (name === 'edit_countries') {
      return <EditCountries />;
    } else if (name === 'intro') {
      return <Intro />;
    } else if (name === 'upload_video') {
      return <UploadVideo />;
    } else if (name === 'cover') {
      return <Cover />;
    } else if (name === 'convert_eur') {
      return <ExchangeEur />;
    } else if (name === 'push_notifications') {
      return <PushNotifications />;
    } else if (name === 'enable_gold') {
      return <EnableGold />;
    } else if (name === 'create_link') {
      return <ReferralsCreateLink />;
    } else if (name === 'links') {
      return <ReferralsLinks />;
    } else if (name === 'referrals_subscribed') {
      return <ReferralsUsers tab={UsersTabsEnum.SUBSCRIBED} />;
    } else if (name === 'referrals_invited') {
      return <ReferralsUsers tab={UsersTabsEnum.INVITED} />;
    } else if (name === 'user_info' && user.verified === 2) {
      return <UserInfo />;
    } else if (name === 'follow_suggestions') {
      return <FollowSuggestions />;
    } else if (name === 'poll') {
      return <NewPoll />;
    } else if (name === 'roulette') {
      return <NewRoulette />;
    } else if (name === 'roulette_lot') {
      return <RouletteLot />;
    } else if (name === 'createApp') {
      return <NewApp />;
    } else if (name === 'code_content') {
      return <PromoCodeContent />;
    } else if (name === 'reel') {
      return <NewReel />;
    } else if (name === 'live_profile') {
      return <Live profile />;
    } else if (name === 'create_bundle') {
      return <CreateBundle />;
    } else if (name === 'edit_bundle') {
      return <CreateBundle editId={route.meta?.options?.id} />;
    } else if ((matches = name.match(/^adventcalendar([0-9-]+)$/))) {
      return <AdventCalendar userId={parseInt(matches[1])} />;
    } else if (name === 'advent_calendar_configuration') {
      return <AdventCalendarConfiguration />;
    } else if ((matches = name.match(/^create_advent_bundle-(\d+)$/))) {
      return <CreateAdventCalendarBundle day={+matches[1]} />;
    } else if ((matches = name.match(/^edit_advent_bundle-(\d+)-(\d+)$/))) {
      return <CreateAdventCalendarBundle day={+matches[1]} bundleId={+matches[2]} />;
    } else if (name === 'bonus_fans') {
      return <BonusFans />;
    } else if (name === 'bonus_fans_referrals') {
      return <BonusFansReferrals />;
    } else if (name === 'create_trial_link') {
      return <CreateTrialLink />;
    } else if (name === 'create_promo_link') {
      return <CreatePromoLink />;
    } else if (name === 'promo_links') {
      return <PromoLinksList />;
    } else if (name === 'new_offer') {
      return <NewOffer />;
    } else if (name === 'edit_offer') {
      return <EditOffer />;
    } else if (name === 'place_spend') {
      return <PlaceSpend />;
    } else if ((matches = name.match(/^mineExploreCard(\d+)$/))) {
      return <MineExploreCardView cardId={+matches[1]} />;
    } else if ((matches = name.match(/^editApp(\d+)$/))) {
      return <EditApp appId={matches[1]} />;
    } else if ((matches = name.match(/^status(\d+)$/))) {
      return <Status groupId={+matches[1]} />;
    } else if ((matches = name.match(/^new_post([0-9-]+)$/))) {
      return <NewPost key={`post_${+matches[1]}`} ownerId={+matches[1]} />;
    } else if ((matches = name.match(/^post(\d+)$/))) {
      return <ViewPost postId={+matches[1]} />;
    } else if ((matches = name.match(/^edit_post(\d+)$/))) {
      return <EditPost postId={+matches[1]} />;
    } else if ((matches = name.match(/^comment(\d+)$/))) {
      return <ViewComment commentId={+matches[1]} />;
    } else if (name === 'live') {
      return <Live />;
    } else if ((matches = name.match(/^live(\d+)$/))) {
      return <Live liveId={+matches[1]} />;
    } else if ((matches = name.match(/^followers([0-9-]+)$/))) {
      return <Followers userId={+matches[1]} />;
    } else if ((matches = name.match(/^followed(\d+)$/))) {
      return <Followers userId={+matches[1]} isOutbox={true} />;
    } else if ((matches = name.match(/^edit(\d+)$/))) {
      return <EditGroup groupId={+matches[1]} />;
    } else if (
      (matches = name.match(
        /^photos\+([a-z0-9]+)(\+([0-9-]+))(\+([0-9]+))?(\+([0-9]+))?$/,
      ))
    ) {
      const [, object, , selected, , instance, , part] = matches;
      return (
        <ViewerWidget
          object={object}
          selectedId={+selected}
          instanceId={instance ? +instance : undefined}
          partId={part ? +part : undefined}
        />
      );
    } else if ((matches = name.match(/^story([a-z0-9]+)(_([0-9-]+))?$/))) {
      return <StoryViewer userId={+matches[1]} storyId={+matches[3]} />;
    } else if ((matches = name.match(/^storyViews(\d+)$/))) {
      return <StoryViews storyId={+matches[1]} />;
    } else if ((matches = name.match(/^group_admins(\d+)$/))) {
      return <GroupAdmins groupId={+matches[1]} />;
    } else if ((matches = name.match(/^scheduled([0-9-]+)$/))) {
      return <Scheduled ownerId={+matches[1]} />;
    } else if ((matches = name.match(/^video\+([a-z0-9]+)(\+(\d+))?$/))) {
      // support legacy video link
      return <ViewerWidget object={matches[1]} selectedId={-matches[3]} />;
    } else if ((matches = name.match(/^likes_([a-z]+)(\d+)$/))) {
      return <Likes objectType={matches[1]} objectId={+matches[2]} />;
    } else if ((matches = name.match(/^bundle([0-9-]+)$/))) {
      return <Bundle id={parseInt(matches[1])} />;
    } else if ((matches = name.match(/^task_([a-z0-9_]+)$/))) {
      return <ViewTask taskId={matches[1]} />;
    } else if ((matches = name.match(/^member_lists([a-z0-9_]+)$/))) {
      return <ListAddMember memberId={+matches[1]} />;
    }

    // ADS MODALS
    if (name === ADS_BALANCE) {
      return <AdsBalance />;
    }
    if (name === ADS_BALANCE) {
      return <CreateTrialLink />;
    } else if (name === ADS_WITHDRAW) {
      return <AdsBalance withdraw />;
    } else if (name === NEW_AD) {
      return <NewAd />;
    } else if (name === NEW_AD_PROFILE) {
      return <NewAdProfile />;
    } else if (name === NEW_AD_POST) {
      return <NewAdPost />;
    } else if (name === NEW_AD_CLIP) {
      return <NewAdClip />;
    } else if (name === NEW_AD_CLIP_PREVIEW) {
      return <NewAdClipPreview />;
    } else if (name === AD_TARGETING) {
      return <AdTargeting />;
    } else if ((matches = name.match(/^ad_users(\d+)$/))) {
      return <AdUsers adId={+matches[1]} />;
    } else if ((matches = name.match(/^ad_targeting(\d+)$/))) {
      return <AdTargeting adId={+matches[1]} />;
    } else if ((matches = name.match(/^ad(\d+)$/))) {
      return <AdView adId={+matches[1]} />;
    } else if ((matches = name.match(/^promote(\d+)$/))) {
      return <PromotePost postId={+matches[1]} />;
    } else if ((matches = name.match(/^ad_preview(\d+)$/))) {
      return <AdPreview adId={+matches[1]} />;
    } else if ((matches = name.match(/^gift(\d+)$/))) {
      return <GiftsStore toId={+matches[1]} />;
    } else if (name === 'send_gift') {
      return <SendGift />;
    }

    return null;
  }, [modalName, user.id]);

  const ActionSheetIsOpen = useActionSheet();

  useEffect(() => {
    if (isPWA() && route?.name === PWA_IOS) {
      router.navigate(FEED, {}, { replace: true });
    }
    //if (!isLoading && isPWA() && !isNotifyEnabled && isNotificationsSupported()) {
    //showModal('push_notifications');
    //}
  }, []);

  const filteredTabs = useMemo(() => {
    return getTabs(t, contentPriority, isLogged, mVerified, user?.isolated);
  }, [t, contentPriority, isLogged, mVerified, user?.isolated]);

  const handleModalOverlay = useCallback(() => {
    if (
      (modalName &&
        (modalName.startsWith('photos+') || modalName.startsWith('video+'))) ||
      ActionSheetIsOpen ||
      document.querySelector('.Input.focused') ||
      document.querySelector('.Editor.focused')
    ) {
      return;
    }

    goBack();
  }, [ActionSheetIsOpen, modalName]);

  const hasOtherBadge = useMemo(() => {
    if (!user) {
      return false;
    }

    for (let account of accounts) {
      if (account.updatesCount > 0 && account.id !== user.id) {
        return true;
      }
    }
    return false;
  }, [accounts, user]);

  const handleCopyCurrentLink = useCallback(() => {
    let url: string;
    try {
      url = decodeURIComponent(decodeURIComponent(location.href));
    } catch (e) {
      url = location.href;
    }

    url = url.replace('?ftg=1', '').replace('&ftg=1', '');
    copyToClipboard(url);
    dispatch(toastActions.setToastSuccess(t('copied')));
  }, [t]);

  function renderPage() {
    if (isInAppBrowser) {
      let url: string;
      try {
        url = decodeURIComponent(decodeURIComponent(location.href));
      } catch (e) {
        url = location.href;
      }
      url = url.replace('?ftg=1', '').replace('&ftg=1', '');
      return (
        <Placeholder
          title={url}
          actions={
            <Button onClick={handleCopyCurrentLink}>
              {t('inapp_browser_error_copy_link')}
            </Button>
          }
        >
          {t('inapp_browser_error')}
        </Placeholder>
      );
    }

    if (
      isForcePaywall &&
      // [PAY_FORM, SUBSCRIPTION_ADULT, SUBSCRIPTION_FIAT, SUBSCRIPTION_FAILED].indexOf(
      [PAY_FORM, SUBSCRIPTION_ADULT, SUBSCRIPTION_FAILED].indexOf(route?.name) === -1
    ) {
      return <ForcedPaywall />;
    }

    switch (route?.name) {
      case MAIN:
      case REF:
        return <Landing />;
      case TRIAL_LINK_ACTIVATION:
        return isLogged ? <Feed /> : <Landing />;
      case POST_VIEW:
        return <ViewPost postId={+route.params.id} />;
      case REGISTRATION:
        return <Registration />;
      case FEED:
        return <Feed />;
      case PROFILE:
        return <Profile />;
      case OTHER:
        return <Other />;
      case SEARCH:
        // if (!isSubscribed) {
        //   if (contentPriority === ContentPriorityType.ADULT) {
        //     return <Paywall skipClose />;
        //   }
        //
        //   return <MediaSubscription />;
        // }

        return <Search />;
      case INVITE:
        return <Invite />;
      // return isAdultUser && user && user.id !== 164669 && user.verified !== 2 ? (
      //   <Referrals />
      // ) : (
      //   <Invite />
      // );
      case GROUP:
        return <Group />;
      case GROUPS:
        return <Groups />;
      case IM:
        if (isForcePaywall) {
          return <ForcedPaywall />;
        } else {
          return <Im />;
        }
      case CHAT:
        return <Chat />;
      case MEDIA:
        return <MediaChat />;
      case BROADCAST:
        return <Broadcast />;
      case BROADCAST_MESSAGE:
        return <BroadcastMessage />;
      case BROADCAST_STATS:
        return <BroadcastStats />;
      case NOTIFY:
        if (isForcePaywall) {
          return <ForcedPaywall />;
        } else {
          return <Notify />;
        }
      case AUTH_REQUIRED:
      case AUTH_PAGE:
        return <AuthRequired />;
      case ACCESS_DENIED:
        return <AccessDenied />;
      case BLOCKED:
        return <Blocked />;
      case COUNTRY_BLOCKED:
        return <CountryBlocked />;
      case FIND_FRIENDS:
        return <FindFriends />;
      case RESOLVE:
      case USER_REF:
      case MODEL_UTM:
        return <Resolver mode="address" domain={route.params.domain} />;
      case VK_AUTH:
        return <VkAuth />;
      case AUTH:
        return <AuthPassword />;
      case SETTINGS:
        return <Settings />;
      case PASSKEY:
        return <Passkey />;
      case API_TOKEN:
        return <ApiToken />;
      case OAUTH_AUTHORIZE:
        return <OauthAuthorize />;
      case ADD_ACCOUNT:
        return <AddAccount />;
      case PASSWORD:
        return <Password />;
      case BIND_EMAIL:
        return <BindEmail />;
      case BIND_EMAIL_CONFIRM:
        return <BindEmailConfirm />;
      case LANGUAGE:
        return <Language />;
      case CONTENT_PRIORITY:
        return <ContentPriority />;
      case GENDER_FILTER:
        return <GenderFilter />;
      case PROMO:
        return <Promo />;
      case RATING:
        return <Rating />;
      case BIRTHDAYS:
        return <Birthdays />;
      case SUBSCRIPTION_AUTHOR:
        return <SubscriptionAuthor />;
      case SUBSCRIPTION_MEDIA:
        return <MediaSubscription />;
      case SUBSCRIPTION_BASIC:
        return <BasicSubscription />;
      case SUBSCRIPTION_ADULT:
        return <Paywall />;
      case CANDY_QR:
        return <CandyQr />;
      case TRIAL_LINKS:
        return <TrialLinks />;
      //return <Subscription type={SubscriptionType.Adult} />;
      case SUBSCRIPTION_ACTIVATED:
        return <SubscriptionActivated />;
      case SUBSCRIPTION_FAILED:
        return <SubscriptionFailed />;
      case BUY_MESSAGE_FAILED:
        return <BuyMessageFailed />;
      case PAY_TIPS_FAILED:
        return <PayTipsFailed />;
      case SUBSCRIPTION_AUTHOR_ACTIVATED:
        return <Subscription type={SubscriptionType.Author} pending={true} />;
      case SUBSCRIPTION_MEDIA_ACTIVATED:
        return <Subscription type={SubscriptionType.Media} pending={true} />;
      case SUBSCRIPTION_ADULT_ACTIVATED:
        return <Subscription type={SubscriptionType.Adult} pending={true} />;
      case SUBSCRIPTION_INFO:
        return <SubscriptionInfo />;
      case SUBSCRIPTION_TONKEEPER:
        return <SubscriptionTonkeeper />;
      case NOTIFY_SETTINGS:
        return <NotifySettings />;
      case VERIFICATION_LANDING:
        return <VerificationLanding />;
      case VERIFICATION_APPLY:
        return <Monetization />;
      case PAY_FORM:
        return <PayForm />;
      case EXPLORE:
        return <Explore />;
      case HOWTO:
      case FAQ:
        window.location.replace(howToRedirectLink);
        return <></>;
      case SUBSCRIPTIONS:
        return <Subscriptions />;
      case PERSONAL_SUBSCRIPTION:
        return <PersonalSubscription />;
      case PERSONAL_SUBSCRIPTION_INFO:
        return <PersonalSubscriptionInfo />;
      case STATISTICS:
        return <Statistics />;
      case STATISTICS_PRO:
        return <StatisticsPro />;
      case STATISTICS_PRO_FANS:
        return <StatisticsProFans />;
      case STATISTICS_PRO_LINKS:
        return <StatisticsProLinks />;
      case STORAGE:
        return <Storage />;
      case SESSIONS:
        return <Sessions />;
      case BLACKLIST:
        return <Blacklist />;
      case WEBSITE_SETTINGS:
        return <WebsiteSettings />;
      case NFT:
        return <NftList />;
      case WELCOME_MESSAGE:
        return <WelcomeMessage />;
      case COMMON_FEED:
        return <CommonFeed />;
      case ADULT_AUTH:
        if (isLogged) {
          return <Paywall />;
        }
        return <AdultAuth />;
      case AUTH_EMAIL:
        return <AuthEmail />;
      case GOOGLE_AUTH:
        return <GoogleAuth />;
      case CLOUD:
        return <Cloud />;
      case ADS:
        return <Ads />;
      case TOP_UP_FAILED:
        return <TopUpFailed />;
      case TOP_UP:
        return <TopUpPage />;
      case LISTS:
        return mVerified ? <UsersLists /> : <NotFound />;
      case CUSTOM_TIPS:
        return <CustomTips />;
      case LIST:
        return mVerified ? <UsersList /> : <NotFound />;
      case INCOGNITO:
        return mVerified ? <Incognito /> : <NotFound />;
      case PRE_LANDING_V1:
        return <ModelsLandingV1 />;
      case PRE_LANDING_V2:
        return <ModelsLandingV2 />;
      case PRE_LANDING_V3:
        return <ModelsLandingV3 />;
      case BATTLE:
        return <Battle />;
      case PWA_IOS:
        return <PwaIos />;
      case BATTLES:
        return <Battles />;
      case STORY_LANDING:
        return <StoryLanding />;
      case LANDING_DIAMOND:
        return <ForcedPaywall />;
      case BOT:
        return <Bot />;
      case APP:
        return <Application />;
      case APPS_MANAGE:
        return <AppsManage />;
      case PROMO_CODE:
        return <PromoCode />;
      case SYSTEM_PROMO_CODE:
        return <SystemPromoCode />;
      case VALENTINE_DAY_STICKER:
        return <SendValentineDaySticker />;
      case REELS:
        // if (!isLogged) {
        //   return <AdultAuth />;
        // }
        // if (!isSubscribed) {
        //   return <Paywall skipClose />;
        // }
        return <ReelsAll />;
      case PROFILE_REELS:
        return <ReelsClips />;
      case MARYANA_LANDING:
        return <MaryanaLanding />;
      case DASHBOARD:
        return <Dashboard />;
      case PAYMENT_METHODS:
        return <PaymentMethods />;
      case REFILL_TON:
        return <RefillTon />;
      case SHOW_SUBSCRIPTION:
        return <ShowSubscription />;
      case ISOLATED_MODE:
        return <IsolatedMode />;
      case TELEGRAM:
        return <Telegram />;
      case OFFERS:
        return <Offers />;
      case VIEW_OFFER:
        return <ViewOffer />;
      case MINE:
        return <Mine />;
      case MINE_SQUAD:
        return <MineSquad />;
      case MINE_BOOST:
        return <MineBoost />;
      case MINE_TOP:
        return <MineTop />;
      case MINE_FRIENDS:
        return <MineFriends />;
      case MINE_SQUAD_BOOST:
        return <MineSquadBoost />;
      case MINE_EXPLORE:
        return <MineExplore />;
      case ONLYPAY_SUCCESS:
        return <OnlypaySuccess />;
      case ONLYPAY_ERROR:
        return <OnlypayError />;
      case FEED_PROMOTION:
        return <FeedPromotion />;
      case BLACK_FRIDAY_2025:
        return <BlackFriday2025 />;
      case FREE_WRITE:
        return <FreeWrite />;
      case LEADERBOARD:
        return <Leaderboard />;
      case LEADERBOARD_DETAILS:
        return <LeaderboardDetails />;
      case DEBUG_PAGE:
        return <DebugPage />;
      case LEADERBOARDS_HISTORY:
        return <LeaderboardsHistory />;
    }

    return <NotFound />;
  }

  function renderModal() {
    if (!modal || isInAppBrowser) {
      return null;
    }

    const name = route?.params?.w ?? '';

    return (
      <ModalWrapper
        name={name}
        aboveAll={route.meta?.options?.aboveAll}
        onOverlayClick={handleModalOverlay}
      >
        <DynamicComponent>{modal}</DynamicComponent>
      </ModalWrapper>
    );
  }

  function renderTabbar() {
    if (isDesktop || isInAppBrowser || isForcePaywall || !isLogged) {
      return null;
    }

    if (
      [
        CHAT,
        SUBSCRIPTION_AUTHOR,
        SUBSCRIPTION_ADULT,
        SUBSCRIPTION_MEDIA,
        STORY_LANDING,
        PROMO_CODE,
        VALENTINE_DAY_STICKER,
        MARYANA_LANDING,
        ADULT_AUTH,
        CANDY_QR,
        TRIAL_LINKS,
        VERIFICATION_LANDING,
        INVITE,
        MINE,
        MINE_SQUAD,
        MINE_TOP,
        MINE_BOOST,
        MINE_FRIENDS,
        MINE_SQUAD_BOOST,
        MINE_EXPLORE,
        LEADERBOARD,
      ].indexOf(route?.name) > -1
    ) {
      return null;
    }

    if ([REF, TRIAL_LINK_ACTIVATION, CUSTOM_TIPS, OAUTH_AUTHORIZE].includes(route?.name))
      return null;

    return (
      <Tabbar
        className={classNames({
          'christmas-style': isChristmasHolidays(),
          transparent:
            (route?.name === REELS && isSubscribed) || route?.name === PROFILE_REELS,
        })}
      >
        {filteredTabs.map((tab) => {
          let hasBadge = false;
          let icon = tab.name === activeTab ? tab.activeIcon : tab.icon;
          if (tab.name === NOTIFY) {
            hasBadge = hasNotify;
          } else if (tab.name === OTHER) {
            hasBadge = hasOtherBadge;

            if (accounts.length > 1) {
              icon = (
                <div
                  className="TabbarItem__user_photo"
                  style={{ backgroundImage: `url(${user.photo})` }}
                />
              );
            }
          } else if (tab.name === REELS) {
            hasBadge = hasReelsBadge;
          }

          return (
            <TabbarItem
              key={tab.name}
              isActive={tab.name === activeTab}
              onClick={handleTab(tab.name)}
              counter={tab.name === IM ? newDialogs : 0}
              badge={hasBadge}
              label={tab.label}
            >
              {icon}
            </TabbarItem>
          );
        })}
      </Tabbar>
    );
  }

  if (route?.params?.tgAuth) {
    const params = { ...route.params };
    delete params.tgAuth;
    if (isLogged) {
      router.navigate(route.name, params, { replace: true });
    } else {
      return (
        <div className="App">
          <Loader isWrapped />
        </div>
      );
    }
  }

  // @ts-ignore
  if (
    (isLoading &&
      route?.name !== STORY_LANDING &&
      route?.name !== RESOLVE &&
      route?.name !== BIND_EMAIL_CONFIRM) ||
    route?.name === PROFILE_LIVE
  ) {
    return (
      <div className="App">
        <Loader isWrapped />
      </div>
    );
  }

  if (route?.name === SHARE_PROFILE || location.hostname === 'tpc.fan') {
    return (
      <DynamicComponent>
        <ShareProfile />
      </DynamicComponent>
    );
  }

  if (isLogged && contentPriority === ContentPriorityType.NONE) {
    return <ContentPriorityPlaceholder centered />;
  }

  if (!isFraudAccepted && user && user.verified === 2) {
    return (
      <>
        <FraudTerms />
        <Toast />
      </>
    );
  }

  if (
    isLogged &&
    user &&
    user.verified === 2 &&
    user.sex !== Sex.FEMALE &&
    user.sex !== Sex.MALE
  ) {
    return (
      <>
        <GenderRequired />
        <Toast />
      </>
    );
  }

  const result = (
    <div className="App">
      <MetaTags faviconIndicator={!!newDialogs} />
      {showInstallPrompt &&
        !PWA_ROUTES_EXCLUDE.includes(route?.name) &&
        !isDesktop &&
        !modal &&
        !window.isWebApp && <PwaBanner />}
      <div
        className={classNames('Content__wrap', {
          fullWidth:
            route?.name === MAIN ||
            route?.name === REF ||
            route?.name === TRIAL_LINK_ACTIVATION ||
            route?.name === PRE_LANDING_V1 ||
            route?.name === PRE_LANDING_V2 ||
            route?.name === PRE_LANDING_V3,
        })}
      >
        <DynamicComponent>{renderPage()}</DynamicComponent>
      </div>
      {renderModal()}
      <Pushes />
      <TrialLinkActivation />
      {isLogged && (
        <>
          <PaySheet />
          <BalancePaySheet />
          <TopUpBalanceSheet />
          <Tips />
          <BattleDonate />
          <Call />
          <TopUpTonSheet />
          <PayInvoiceSheet />
          <PayConfirmSheet />
          <CreateMenuSheet />
          <TelegramBotSheet />
          <TelegramChooseChatSheet />
        </>
      )}
      <div id="date-picker-portal"></div>
      <div id="media-viewer-portal"></div>
      {(offline || error) && (
        <DynamicComponent>{offline ? <Offline /> : <Error />}</DynamicComponent>
      )}
      <Captcha />
      {renderTabbar()}
      <Toast />
      {popup}
      {/*{!isLogged && route?.name !== MAIN && route?.name !== AUTH_REQUIRED && route?.name !== REGISTRATION && (*/}
      {/*  <CreateAccountPopover />*/}
      {/*)}*/}
      <ConfirmCode />
      <Confirm />
      <Prompt />
      <PasskeyAuthorization />
      {!isLogged && !isLoading && route?.name !== ONLYPAY_SUCCESS && <AgePopover />}
    </div>
  );

  if (
    isDesktop &&
    route?.name !== STORY_LANDING &&
    route?.name !== MAIN &&
    !isForcePaywall
  ) {
    return (
      <div
        className={classNames('App__desktop_wrap', {
          _wide: isAdultUser && route?.name === INVITE && (!user || user.verified !== 2),
          App__desktop_nowrap: route?.name === REF,
        })}
      >
        {![REF, TRIAL_LINK_ACTIVATION, OAUTH_AUTHORIZE].includes(route?.name) && (
          <div className="App__desktop_menu">
            <Navbar activeTab={activeTab} />
          </div>
        )}
        <div
          className={classNames('App__desktop_cont', {
            'App__desktop_max-width': [REF, TRIAL_LINK_ACTIVATION].includes(route?.name),
          })}
        >
          {result}
        </div>
      </div>
    );
  }

  return result;
}

function TabLottieIcon({ data, autoplay }: any) {
  const ref: any = useRef();
  useEffect(() => {
    if (autoplay) {
      ref.current.play();
    }
    return () => ref.current.stop();
  });
  return (
    <Lottie
      lottieRef={ref}
      animationData={data}
      autoplay={false}
      loop={false}
      style={{ height: 47, width: 47, transform: 'translate(-11.5px, -11.5px)' }}
    />
  );
}

export default App;
